



































import differenceInDays from 'date-fns/differenceInDays';
import isAfter from 'date-fns/isAfter';
import Vue, { PropOptions } from 'vue';
import { CourseraAccessType } from '~/models';
import BillingService, { BillingAccount } from '~/services/BillingService';
import CourseraService from '~/services/CourseraService';
import URLS from '~/URLS';
import BaseCard from './BaseCard.vue';

export default Vue.extend({
    name: 'NonSubscriptionAccessCard',
    components: {
        BaseCard,
    },
    props: {
        billingAccount: {
            type: Object,
            required: true,
        } as PropOptions<BillingAccount>,
        accessType: {
            type: String,
            required: true,
        } as PropOptions<CourseraAccessType | null>,
        expiresAt: {
            type: Date,
            required: true,
        } as PropOptions<Date | null>,
    },
    data() {
        return {
            priceId: null as string | null,
        };
    },
    computed: {
        headerText(): string {
            switch (this.accessType) {
                case CourseraAccessType.Purchase:
                    return this.$t(
                        'plansAndBilling.nonSubscriptionAccess.headerPurchase'
                    ).toString();
                case CourseraAccessType.Code:
                    return this.$t(
                        'plansAndBilling.nonSubscriptionAccess.headerAccessCode'
                    ).toString();
                case CourseraAccessType.Invite:
                default:
                    return this.$t('plansAndBilling.nonSubscriptionAccess.headerInvite').toString();
            }
        },
        subHeaderText(): string {
            return this.$t('plansAndBilling.planDetails.coursesAndProjects', {
                courses: '5000+',
                projects: '1900+',
            }).toString();
        },
        isExpired(): boolean {
            return !this.expiresAt ? true : isAfter(new Date(), this.expiresAt);
        },
        daysLeft(): string {
            const days = !this.expiresAt ? 0 : differenceInDays(this.expiresAt, new Date());
            return this.$tc('plansAndBilling.planDetails.daysLeft', days).toString();
        },
    },
    methods: {
        getMonthlySubscriptionPriceId() {
            BillingService.getProductsByTags({
                category: 'coursera',
                type: 'month',
            })
                .then(products => {
                    for (const prod of products)
                        for (const price of prod.prices) if (price.active) return price.id;
                    return null;
                })
                .then(priceId => (this.priceId = priceId))
                .catch(console.error);
        },

        async handleSetupSubscription() {
            if (!this.priceId) return;

            const session = await CourseraService.setupFutureSubscription(
                this.billingAccount.id,
                this.priceId,
                window.location.href
            ).catch(err => {
                console.error(err);
                window.alert('Something went wrong');
                return null;
            });
            if (!session) return;

            BillingService.redirectToStripeSession(session);
        },
        handleGetAccess() {
            this.$router.push(URLS.courseraChooseSubscription);
        },
    },
    mounted() {
        this.getMonthlySubscriptionPriceId();
    },
});
